import { styled } from "styled-system/jsx";

export const VideoIcon = () => {
  return (
    <styled.svg
      w={"288px"}
      viewBox="0 0 400 225"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transition={"filter 0.3s ease"}
      borderRadius={"22px"}
      boxShadow={"0px 25px 40px -18px rgba(10, 10, 10, 0.20)"}
      transform={"rotate(-3deg)"}
      _hover={{ filter: "brightness(0.85) contrast(1.5)" }}
    >
      <g clipPath="url(#clip0_4336_28636)">
        <rect width="400" height="225" rx="24" fill="#4BCE97" />
        <path
          d="M214.134 -17.5446C243.221 6.72922 252.644 59.1855 241.378 105.882C229.907 152.578 197.747 193.515 161.081 202.772C124.21 212.234 82.8325 189.812 44.7325 168.418C6.6324 147.024 -28.1902 126.659 -38.637 96.2134C-48.879 65.7682 -34.7451 25.2432 -9.54988 1.79216C15.4405 -21.6589 51.4921 -28.2416 93.8938 -33.3844C136.295 -38.3214 185.047 -42.0242 214.134 -17.5446Z"
          fill="#7EE2B8"
        />
        <path
          opacity="0.75"
          d="M422.42 117.236C454.401 145.304 468.107 199.082 452.613 238.337C437.318 277.788 392.625 302.715 350.315 316.847C308.204 330.782 268.278 333.922 233.914 319.987C199.55 305.855 170.549 274.648 156.446 234.019C142.144 193.391 142.74 143.537 167.569 117.04C192.399 90.5432 241.462 87.4028 290.923 87.0103C340.582 86.814 390.639 89.1693 422.42 117.236Z"
          fill="#BAF3DB"
        />
        <path
          d="M179.76 83.5803C178.21 82.6619 176.25 83.779 176.25 85.5805V139.42C176.25 141.221 178.21 142.338 179.76 141.42L225.187 114.5C226.707 113.6 226.707 111.4 225.187 110.5L179.76 83.5803Z"
          fill="#27272A"
        />
      </g>
      <defs>
        <clipPath id="clip0_4336_28636">
          <rect width="400" height="225" rx="24" fill="white" />
        </clipPath>
      </defs>
    </styled.svg>
  );
};
